import { render, staticRenderFns } from "./PreisanfrageFormular.vue?vue&type=template&id=39f2ef24&scoped=true&"
import script from "./PreisanfrageFormular.vue?vue&type=script&lang=js&"
export * from "./PreisanfrageFormular.vue?vue&type=script&lang=js&"
import style0 from "./PreisanfrageFormular.vue?vue&type=style&index=0&id=39f2ef24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2ef24",
  null
  
)

export default component.exports